import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from './modal.service';

@Component({
  selector: 'atlas-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {
  public isMobile$: Observable<boolean>;

  constructor(private modalService: ModalService) {
    this.isMobile$ = this.modalService.mobile$;
  }
}
